<app-header></app-header>
<div class="auth-page-container with-header">
  <div class="brands-showcase-wrapper">
    <brands-showcase tone="light"></brands-showcase>
  </div>
  <div class="py-2">
    <router-outlet></router-outlet>
  </div>
</div>
